module.exports = __webpack_public_path__ + "static/media/ithra.9ae8a869.svg";